import React from 'react';
import PipelineStatusEditorTabs from './PipelineStatusEditorTabs.js';
import PipelineStatusEditorDetails from './PipelineStatusEditorDetails.js';

const PipelineStatusEditor = ({ state, onChange }) => {
  return (
    <div className="pipeline-status-editor">
      <PipelineStatusEditorTabs statusId={state.statusId} onChange={onChange} />
      <PipelineStatusEditorDetails state={state} onChange={onChange} />
    </div>
  );
};

export default PipelineStatusEditor;
